import { msalInstance } from "../index";
import { loginRequest } from "../authConfig";

export async function getDecisions() {
    return getAuthenticated("/api/decisions")
}

export async function getAllDecisions() {
    return getAuthenticated("/api/decisions/all")
}

export async function getDecision(decisionId) {
    return getAuthenticated(`/api/decisions/${decisionId}`)
}

export async function getDraws(decisionId) {
    return getAuthenticated(`/api/decisions/${decisionId}/draws`);
}

export async function getDraw(drawId) {
    return getAuthenticated(`/api/draws/${drawId}`);
}

export async function getItems() {
    return getAuthenticated("/api/items");
}

export async function getItem(itemId) {
    return getAuthenticated(`/api/items/${itemId}`)
}

export async function getWants() {
    return getAuthenticated("/api/wants")
}

export async function getWant(wantId) {
    return getAuthenticated(`/api/wants/${wantId}`)
}

export async function getRandomNumber(max) {
    return getAuthenticated(`/api/random?max=${max}`)
}

export async function saveWant(want) {
    return postAuthenticated(`/api/wants`, want)
}

export async function saveItem(item) {
    return postAuthenticated("/api/items", item)
}

export async function deleteItem(itemId) {
    return deleteAuthenticated(`/api/items/${itemId}`)
}

export async function saveDraw(draw) {
    return postAuthenticated(`/api/draws`, draw)
}

export async function saveDecision(decision) {
    return postAuthenticated(`/api/decisions`, decision);
}

export async function saveMileage(mileage) {
    return postAuthenticated("/api/car", {
        mileage: mileage
    })
}

export async function getAocChallenges() {
    return getAuthenticated("/api/aoc-challenges")
}

export async function getRandomAoc() {
    return getAuthenticated("/api/aoc-challenges/random")
}

export async function deleteAcoChallenge(challengeId){
    return postAuthenticated(`/api/aoc-challenges/${challengeId}`, {})
}

export async function getTimeLogs(workDate) {
    return getAuthenticated(`/api/timelogs?workDate=${workDate}`)
}

export async function getTimeLog(timeLogId) {
    return getAuthenticated(`/api/timelogs/${timeLogId}`)
}

export async function saveTimeLog(timeLog) {
    return postAuthenticated("/api/timelogs", timeLog)
}

export async function getSwimlanes() {
    return getAuthenticated("/api/wants/swimlanes")
}

export async function getSwimlane(id) {
    return getAuthenticated(`/api/wants/swimlanes/${id}`)
}

export async function saveSwimlane(swimlane) {
    return postAuthenticated(`/api/wants/swimlanes`, swimlane)
}

async function getAuthenticated(uri) {
    const headers = new Headers()
    const token = await getToken()
    headers.append("Authorization", `Bearer ${token}`)
    
    const options = {
        method: "GET",
        headers: headers
    }
    
    return fetch(uri, options)
        .then(response => response.json())
        .catch(error => console.log(error))
}

async function postAuthenticated(uri, data) {
    const token = await getToken()

    const headers = new Headers()
    headers.append("Authorization", `Bearer ${token}`)
    headers.append("Content-Type", "application/json")

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data)
    }

    return fetch(uri, options)
        .then(response => {
            if (response.status !== 200) {
                throw `Error ${response.status} during api call`
            }
            return response.json() 
        })
}

async function deleteAuthenticated(uri) {
    const token = await getToken()

    const headers = new Headers()
    headers.append("Authorization", `Bearer ${token}`)

    const options = {
        method: "DELETE",
        headers: headers
    }

    return fetch(uri, options)
        .then(response => {
            if (response.status !== 200) {
                throw `Error ${response.status} during api call`
            }
            return response.json()
        })
}

async function getToken() {
    try {
        const account = msalInstance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in.");
        }

        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });

        return response.accessToken;
    } catch (error) {
        console.log("Silent token acquisition failed. Using interactive method.");
        console.log(error);
        
        // Fallback to interactive token acquisition
        const response = await msalInstance.acquireTokenPopup(loginRequest);
        return response.accessToken;
    }
}
